import React, { useState } from "react";
import {
  FaSearch,
  FaMapMarkerAlt,
  FaBriefcase,
  FaTimes,
} from "react-icons/fa";
import "./Careers.css";

const OpenPositions = () => {
  const jobsData = [
    {
      id: 1,
      title: "Frontend Developer",
      type: "Full Time",
      location: "Noida, India",
      department: "Development",
    },
    {
      id: 2,
      title: "UI/UX Designer",
      type: "Full Time",
      location: "Noida",
      department: "Design",
    },
    {
      id: 3,
      title: "MERN Stack Developer",
      type: "Full Time",
      location: "Noida, India",
      department: "Development",
    },
  ];

  const [search, setSearch] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [selectedJob, setSelectedJob] = useState("");

  const filteredJobs = jobsData.filter((job) =>
    job.title.toLowerCase().includes(search.toLowerCase())
  );

  const openForm = (title) => {
    setSelectedJob(title);
    setShowForm(true);
  };

  const closeForm = () => {
    setShowForm(false);
  };

  return (
    <section className="backdiv">
      <div>
       
          <h2 className="main-title">Find Your Next Opportunity</h2>
        
       

        {/* Search */}
        <div className="positions-search">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search jobs..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

          <p className="positions-subtext">
            Explore exciting career opportunities and become part of our growing team.
          </p>

        {/* Job Cards */}
        <div className="positions-list">
          {filteredJobs.map((job) => (
            <div className="job-card" key={job.id}>
              <div className="job-left">
                <h3>{job.title}</h3>

                <div className="job-info">
                  <span><FaBriefcase /> {job.type}</span>
                  <span><FaMapMarkerAlt /> {job.location}</span>
                  <span>{job.department}</span>
                </div>
              </div>

              <button
                className="apply-btn"
                onClick={() => openForm(job.title)}
              >
                Apply Now
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Popup Form */}
      {showForm && (
        <div className="job-popup">
          <div className="job-form-box">
            <button className="close-btn" onClick={closeForm}>
              <FaTimes />
            </button>

            <h2>Apply for {selectedJob}</h2>

            <form>
              <input type="text" placeholder="Full Name" required />
              <input type="email" placeholder="Email Address" required />
              <input type="tel" placeholder="Phone Number" required />
              <input type="file" />
              <textarea placeholder="Why should we hire you?" rows="4"></textarea>

              <button type="submit" className="submit-btn">
                Submit Application
              </button>
            </form>
          </div>
        </div>
      )}
    </section>
  );
};

export default OpenPositions;